'use strict';

angular.module('studies')
    .component('studiesTable', {
        templateUrl: 'js/modules/studies/components/table/template.html',
        controller: 'StudiesTableController',
    });
